module.exports = __webpack_public_path__ + "img/V24.74f6f405.jpg";